import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { NEVER, Observable, fromEvent } from 'rxjs';

import { LogoutService } from '../../logout/logout.service';

export const LOGOUT_FORM_SELECTOR = '.js-logout-form';
export const SWITCH_ACCOUNT_FORM_SELECTOR = '#dashboardSelectAccountOverlayForm';

@Injectable({
  providedIn: 'root'
})
export class LegacyLogoutService extends LogoutService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    super();
  }

  public logout$(): Observable<Event> {
    return this.addEventObservable(LOGOUT_FORM_SELECTOR, 'submit');
  }

  public switchAccount$(): Observable<Event> {
    return this.addEventObservable(SWITCH_ACCOUNT_FORM_SELECTOR, 'form:submit');
  }

  private addEventObservable(selector: string, eventName: string): Observable<Event> {
    const form = this.document.querySelector(selector);
    if (form) {
      return fromEvent(form, eventName);
    } else {
      return NEVER;
    }
  }
}
